import type {FallbackRender} from '@sentry/react';
import {useTitle} from 'hooks';
import {NavbarCommon, Transitioner} from 'components';

const ErrorFallback = ({error, componentStack, eventId}: Parameters<FallbackRender>[0]) => {
  useTitle('Error');

  const errorMessage = typeof error === 'string' ? error : (error as any).message;
  const isDev = import.meta.env.DEV;

  return (
    <div className="min-h-screen flex flex-col">
      <NavbarCommon />
      <Transitioner>
        <section className="flex flex-col justify-center items-center flex-1 p-6 sm:pt-12 lg:px-8">
          <p className="text-center text-red-500 text-[84px] md:text-[140px] font-bold -mb-3">Error</p>
          <p className="text-center text-xl dark:text-white md:text-2xl font-semibold mb-3">Oops! An error occurred.</p>
          <p className="text-center text-lg mb-6">Sorry, you may refresh the page to try again.</p>
          <button
            type="button"
            onClick={() => location.reload()}
            className="border border-slate-700 p-4 rounded-full transition duration-200 hover:bg-slate-100 dark:hover:bg-slate-700 cursor-pointer">
            Refresh Page
          </button>
          {isDev && !!errorMessage && (
            <div className="flex flex-col pb-32">
              <p className="text-center text-red-500 font-medium mt-6 mb-2 select-text">Sentry event ID: {eventId}</p>
              <p className="text-center text-red-500 font-medium text-lg select-text">{errorMessage}</p>
              <code className="w-full bg-black text-white rounded-md p-3 mt-6 whitespace-pre-line">{componentStack}</code>
            </div>
          )}
        </section>
      </Transitioner>
    </div>
  );
};

export default ErrorFallback;
